import { Route } from "@angular/router";

export const JobsPaths = {
  Start: "start",
  Add: "toevoegen",
  VolunteerCorps: "vrijwilligerskorps",
  Edit: (jobId: number | string) => `bewerken/${jobId}`,
  SmallEdit: (jobId: number | string) => `nakijken/${jobId}`,
  List: "Overzicht",
  Templates: "sjablonen",
  TemplateAdd: "sjablonen/toevoegen",
  TemplateEdit: (jobId: number | string) => `sjablonen/bewerken/${jobId}`,
  Spotlight: "uitgelicht",
  VwwList: "vwwOverzicht",
};

export default [
  {
    path: JobsPaths.Start,
    loadComponent: () =>
      import("./pages/jobs-start/jobs-start.component").then((c) => c.JobsStartComponent),
    data: {
      breadcrumb: "Start",
      title: "Vacatures",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: "search",
    redirectTo: JobsPaths.List,
  },
  {
    path: JobsPaths.Add,
    loadComponent: () => import("./pages/add-job/add-job.component").then((c) => c.AddJobComponent),
    data: {
      breadcrumb: "Vacature toevoegen",
      title: "Vacature toevoegen",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.VolunteerCorps,
    loadComponent: () =>
      import("./pages/create-volunteer-corps/create-volunteer-corps.component").then(
        (c) => c.CreateVolunteerCorpsComponent
      ),
    data: {
      breadcrumb: "Vacature toevoegen",
      title: "Vacature toevoegen",
      volunteerCorps: true,
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.Edit(":id"),
    loadComponent: () => import("./pages/add-job/add-job.component").then((c) => c.AddJobComponent),
    data: {
      breadcrumb: "Vacature bewerken",
      title: "Vacature bewerken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.SmallEdit(":id"),
    loadComponent: () =>
      import("./pages/job-edit-small/job-edit-small.component").then(
        (c) => c.JobEditSmallComponent
      ),
    data: {
      breadcrumb: "Vacature nakijken",
      title: "Vacature nakijken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: "",
    redirectTo: JobsPaths.List,
    pathMatch: "full",
  },
  {
    path: JobsPaths.List,
    loadComponent: () =>
      import("./pages/search-job/search-job.component").then((c) => c.SearchJobComponent),
    data: {
      breadcrumb: "Overzicht",
      title: "Vacatures",
      loadTemplates: false,
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.Templates,
    loadComponent: () =>
      import("./pages/search-job/search-job.component").then((c) => c.SearchJobComponent),
    data: {
      breadcrumb: "Sjablonen beheren",
      title: "Sjablonen voor vacatures beheren",
      loadTemplates: true,
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.TemplateAdd,
    loadComponent: () => import("./pages/add-job/add-job.component").then((c) => c.AddJobComponent),
    data: {
      breadcrumb: "Sjabloon voor vacature",
      title: "Sjabloon voor vacature",
      isTemplate: true,
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.TemplateEdit(":id"),
    loadComponent: () => import("./pages/add-job/add-job.component").then((c) => c.AddJobComponent),
    data: {
      breadcrumb: "Sjabloon bewerken",
      title: "Sjabloon voor vacature bewerken",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.Spotlight,
    loadComponent: () =>
      import("./pages/highlight/highlight.component").then((c) => c.HighlightComponent),
    data: {
      breadcrumb: "Vrijwilligers in de kijker",
      title: "Vrijwilligers in de kijker",
      subscriptionTypes: [1, 4, 5],
    },
  },
  {
    path: JobsPaths.VwwList,
    loadComponent: () =>
      import("./pages/search-vww-job/search-vww-job.component").then(
        (c) => c.SearchVwwJobComponent
      ),
    data: {
      breadcrumb: "Vrijwilligerswerk vacatures",
      title: "Vrijwilligerswerk vacatures",
      subscriptionTypes: [1, 4, 5],
    },
  },
] satisfies Route[];
